import { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  from {
    background-color: rgba(0, 0, 0, 0);
    visibility: hidden;
  }

  to {
    background-color: rgba(0, 0, 0, 0.5);
    visibility: visible;
  }
`;

export const fadeOut = keyframes`
  from {
    background-color: rgba(0, 0, 0, 0.5);
    visibility: visible;
  }

  to {
    background-color: rgba(0, 0, 0, 0);
    visibility: hidden;
  }
`;

export const slideInAndFade = keyframes`
  from {
    transform: translateY(-20px);
    opacity: 0;
  }

  to {
    transform: translateY(0px);
    opacity: 1;
  }
`;

export const slideOutAndFade = keyframes`
  from {
    transform: translateY(0px);
    opacity: 1;
  }

  to {
    transform: translateY(-100px);
    opacity: 0;
  }
`;
